export enum MessageType {
  Image = "i",
  Text = "t",
  SystemSuccess = "system_success",
  SystemWarning = "system_warning",
  SystemError = "system_error",
  UserInfo = "user_info",
}
